<template>
  <section
    class="modal"
    :id="id"
    @click.self="allowCloseModalByClickingOutside && emitCloseModal()"
    :class="{ 'above-all': isAboveAll, darker }"
  >
    <article class="modal-container">
      <div class="header" v-if="!hideHeader">
        <img v-if="headerIcon" :src="headerIcon" :alt="headerIconAlt" />
        <p :class="{ 'slate-bold': boldFonts }">{{ headerTitle }}</p>
        <CloseButton @close="emitCloseModal()" />
      </div>

      <div class="content">
        <slot name="content"></slot>
      </div>

      <div class="buttons-container" v-if="!hideButtonsContainer">
        <template v-if="!showButtonLoader">
          <button
            v-if="!hideCancelButton"
            class="btn cancel"
            @click="emitCloseModal()"
          >
            {{ cancelText }}
          </button>
          <button
            class="btn confirm"
            @click="$emit('confirm')"
            :disabled="disableConfirmationButton"
            :class="{
              'slate-bold': boldFonts,
            }"
          >
            {{ confirmationText }}
          </button>
        </template>
        <Loader v-else />
      </div>
    </article>

    <transition name="fade">
      <Modal
        :darker="true"
        :hideHeader="true"
        :hideButtonsContainer="true"
        v-if="showLoader"
      >
        <template #content>
          <Loader :withMessage="!!loaderMessage" :message="loaderMessage" />
        </template>
      </Modal>
    </transition>
  </section>
</template>

<script>
import CloseButton from "@/components/Utils/CloseButton.vue";
import Loader from "@/components/Utils/Loader.vue";
export default {
  name: "Modal",

  props: {
    allowCloseModalByClickingOutside: {
      type: Boolean,
      default: true,
    },
    boldFonts: { type: Boolean, default: false },
    cancelText: { type: String, default: "Cancel" },
    confirmationText: { type: String, default: "Ok" },
    darker: {
      type: Boolean,
      default: false,
    },
    disableConfirmationButton: {
      type: Boolean,
      default: false,
    },
    headerIcon: {
      type: String,
      default: "",
    },
    headerIconAlt: {
      type: String,
      default: "",
    },
    headerTitle: {
      type: String,
      default: "",
    },
    hideButtonsContainer: {
      type: Boolean,
      default: false,
    },
    hideCancelButton: {
      type: Boolean,
      default: false,
    },
    hideHeader: {
      type: Boolean,
      default: false,
    },
    isAboveAll: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
    },
    loaderMessage: {
      type: String,
      default: "",
    },
    showButtonLoader: {
      type: Boolean,
      default: false,
    },
    showLoader: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    CloseButton,
    Loader,
  },

  methods: {
    emitCloseModal() {
      this.$emit("closeModal");
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(40, 42, 48, 0.08);
  margin-bottom: 0 !important;
  z-index: 100;

  &.above-all {
    position: fixed;
  }

  &.darker {
    background-color: #26262c52;
  }

  .modal-container {
    width: 30%;
    max-width: 600px;
    margin: auto;
    background: white;
    border-radius: 6px;
    box-shadow: 0px 3px 6px -3px #00000036;
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 1.2rem;
      border-bottom: 1px solid $grey-light;
      p {
        text-transform: capitalize;
        margin-right: auto;
        margin-left: 0.5rem;
      }
    }

    .content {
      display: flex;
      flex-flow: column;
      padding: 1.3rem 1.5rem;
      p.text {
        color: $grey-dark;
      }

      .url-container {
        display: flex;
        justify-content: space-between;
        border: 1px solid #eaeaea;
        border-radius: 6px;
        overflow: hidden;
        .url {
          padding: 0.5rem;
          color: $dark;
          text-decoration: underline;
        }

        button {
          background-color: $dark;
          border-radius: 0 !important;
          color: white;
          padding: 0 0.5rem;
        }
      }

      p.msg {
        padding: 0.5rem 0;
        color: $green;
      }
    }

    .buttons-container {
      display: flex;
      justify-content: space-evenly;
      margin-left: auto;
      padding: 1rem 0;
      gap: 1rem;

      .btn {
        background: $dark;
        color: white;
        border-radius: 6px;
        padding: 0.5rem 1rem;
        outline: none;
        cursor: pointer;
        font-family: "SlateStd", Helvetica, Arial;

        &#send-quote-btn {
          font-size: 16px;
          padding: 0.75rem 2rem;
        }

        &.confirm {
          display: flex;
          align-items: center;
          background: $dark;
          color: white;
          text-transform: capitalize;
        }

        &.cancel {
          color: $grey-dark;
          background: none;
          &:hover {
            text-decoration: underline;
          }
        }

        &.white-btn {
          background: #fff;
          box-shadow: 0 0 10px -2px #0000004d;
          color: $dark;
          &:hover {
            color: #fff;
            background: $dark;
          }
        }
        &.black-btn {
          color: #fff;
          background-color: $dark;
          border-color: #fff;
          &:hover {
            color: $dark;
            background-color: #fff;
            border: 1px solid $dark !important;
            border-color: $dark;
          }
        }

        &:disabled {
          background: $grey-light;
          color: $dark;
          cursor: not-allowed !important;
        }

        @media screen and (max-width: 1200px) {
          margin-right: 0;
          margin: auto;
        }
      }
    }

    @media screen and (max-width: 1024px) {
      width: 50%;
    }
  }
}
</style>
